import { LanguageRoutes } from './constants/LanguageTypes';
import { IFlashMessageTypes } from '../../shared/public/SlFlashMessage/SlFlashMessage';
import { CodeLanguages } from '../../api/private/global.interface';
import {
	ISolveMaterialPayload, IMaterialInfo, IMaterialSolutionSubmission, ICodeSolution,
} from '../../api/private/learn-engine-api/learn-engine-api.interface';
import {
	IUserCodePayload, ICodeCompilePayload, DefaultCodeLanguages, IUserCode, ICodeTemplate,
} from '../../api/public/code-api';

export interface IAction {
    type: ActionType;
    requestType?: RequestType;
    data?: IActionData;
}
export enum ActionType {
    // Business actions
    InitPlayground,
    MakeFreeze,
    ResetContainer,
    OpenConsole,

    // Click handlers
    OnHeaderRenameBtnClick,
    OnHeaderSaveBtnCLick,
    OnHeaderCompileBtnCLick,
    OnHeaderPublishCodeToggle,
    OnHeaderChangeModeToggle,
    OnRunBtnClick,
    OnModalSaveBtnClick,
    OnCloseConsoleClick,
    OnConsoleClick,
    OnModalDiscardChangesBtnClick,
    OnMaterialNotFoundClick,
    onCloseModalSaveBtnClick,
    onCloseModalDiscardBtnClick,

    // Change handlers
    OnTIYWidgetInputChange,

    // Mount handlers
    OnPlaygroundContainerMount,

    // Network communication
    SaveUserCode,
    SaveCode,
    GetMaterial,
    SolveMaterial,

    // Tracking
    Track,
}
export enum RequestType {
    Parallel,
    Cancelable,
    Sequential,
}

export interface IActionData {
    codeId?: string;
    tiyWidgetCodes?: ICodeSolution[];
    templateId?: number;
    code?: string;
    language?: CodeLanguages | LanguageRoutes | string;
    input?: string;
    saveCodePayload?: IUserCodePayload;
    compileCodePayload?: ICodeCompilePayload;
    jsCode?: string;
    cssCode?: string;
    sourceCode?: string;
    name?: string;
    isPublic?: boolean;
    defaultCodeLanguage?: DefaultCodeLanguages;
    id?: number;
    callback?: () => void;
    publicId?: string;
    hasLanguageTypeScreen?: boolean;
    errorHandler?: { [key: string]: () => void };
    state?: boolean;
    topLevelDomain?: string;
    routeData?: IRouteData;
    // Added
    inputName?: string;
    materialId?: number;
    codeData?: IUserCode | IUpdatedCodeTemplate;
    solveMaterialPayload?: ISolveMaterialPayload;
    trackData?: ITrackActionData;
}

export enum SlPlaygroundActionTypes {
    getUserCode = 'getUserCode',
    getTemplate = 'getTemplate',
    saveUserCode = 'saveUserCode',
    compileCode = 'compileCode',
    compileWebCode = 'compileWebCode',
    getDefaultCode = 'getDefaultCode',
    publishCode = 'publishCode',
    continueAfterCodeSaving = 'continueAfterCodeSaving',
    changeEditorMode = 'changeEditorMode',
    makeFreeze = 'makeFreeze',
    getCodeData = 'getCodeData',
    resetContainer = 'resetContainer',
    initApp = 'initApp',
    initPlayground = 'initPlayground',

    onHeaderCompileCode = 'onHeaderCompileCode',
    onHeaderSaveCode = 'onHeaderSaveCode',
    onHeaderPublishCode = 'onHeaderPublishCode',
    onHeaderCloseIcon = 'onHeaderCloseIcon',
    onHeaderRenameCode = 'onHeaderRenameCode',
    onModalCompileCode = 'onModalCompileCode',
    toggleConsole = 'toggleConsole',
    openConsole = 'openConsole',
    SlTiyRunCall = 'SlTiyRunCall',
}

export interface IError {
    code: number;
    message: string;
    field?: string;
    errorType?: string;
}

export interface IErrorsState extends IError {
    type?: SlPlaygroundActionTypes;
}

export enum IModalStates {
    CLOSE = 'close',
    OPEN = 'open',
}

export interface IUpdatedCodeTemplate extends ICodeTemplate {
    sourceCode: string;
    name?: string;
    isPublic?: boolean;
    userId?: number;
    avatarUrl?: string;
    userName?: string;
    publicId?: string;
}

export interface IFlashMessage {
    type: IFlashMessageTypes;
    message: string;
}

export interface ITrackAction {
    action: string;
    element: string;
    entityId?: number;
    redirectUrl?: string;
    userId?: string;
}

export interface ITagManagerAction {
    event: string;
    userId?: number;
    language?: CodeLanguages;
}

export interface IRouteData {
    returnUrl?: string;
    courseAlias?: string;
}
export enum TrackEventName {
    MaterialImpression = 'material_impression',
    MaterialSolve = 'material_solution_impression',
    MaterialQuit = 'material_quit',
    MaterialCTAClick = 'material_cta_click',
}

export enum TrackActionName {
    OnMaterialMount = 'onMaterialMount',
    MaterialSolve = 'materialSolve',
    MaterialQuit = 'materialQuit',
    MaterialCTAClick = 'materialCTAClick',
}

export interface ITrackActionData {
    actionName: TrackActionName;
    relationId?: number;
    materialInfo?: IMaterialInfo;
    solution?: IMaterialSolutionSubmission;
    quitAction?: MaterialQuitAction;
    materialCTAClickType?: MaterialCTAClickType;
}

export enum MaterialQuitAction {
    XButton = '1',
    ModalLeave = '2',
    DontCommit = '3',
    Commit = '4',
    Save = '5',
    Publish = '6',
}

export enum MaterialCTAClickType {
    Run = '4',
    Save = '5',
}
